import { render } from "./LoaderView.vue?vue&type=template&id=8ece0550"
import script from "./LoaderView.vue?vue&type=script&lang=js"
export * from "./LoaderView.vue?vue&type=script&lang=js"

import "./LoaderView.vue?vue&type=style&index=0&id=8ece0550&lang=scss"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__